import '@fortawesome/fontawesome-free/css/all.css'

import Vue from 'vue'

import App from './App'

import './config/bootstrap'
import './config/axios'
import './config/msgs'

import store from './config/store'
import router from './config/router'
import Vuelidate from './config/vuelidate'
import Maps from './config/maps'


Vue.config.productionTip = false

new Vue({
  store,
  router,
  Vuelidate,
  Maps,
  render: h => h(App)
}).$mount('#app')


// Azul escuro: #005494
// Azul escuro grad: #0080e1
// Azul claro: #0bb1e7
// Cinza: #949ca1